import { Route } from '@angular/router';
import { attributes } from './attributes';
import { companies } from './companies';
import { tags } from './tags';
import { RoutingID } from '../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { colors } from './colors';

export const masterdata: Route = {
  path: 'masterdata',
  title: 'nav.masterData',
  data: {
    icon: SbIcons.masterData,
    breadcrumb: 'nav.masterData',
    id: RoutingID.masterData,
  },
  children: [
    attributes,
    companies,
    tags,
    colors,
    // timeTypes,
    { path: '', redirectTo: RoutingID.companies, pathMatch: 'full' },
  ],
};
